const shifts = {
  toast: {
    error: {
      badResponse: '[Rate] bad server response',
    },
  },

  create: {
    errorToast: {
      message: 'Error Occurred. Could Not Create Shift',
    },
    successToast: {
      message: 'Success! Shift Created Successfully',
    },
  },

  delete: {
    errorToast: {
      message: 'Error Occurred. Could Not Delete Shift',
    },
    successToast: {
      message: 'Success! shifts successfully deleted.',
    },
    confirmation: {
      header: 'Delete shifts confirmation',
      body: {
        dynamic: 'You are about to delete {{numShifts}} shifts.',
        all: 'You are about to delete all shifts.',
      },
    },
  },

  edit: {
    errorToast: {
      message: 'Error Occurred. Could Not Update Shift',
    },
    successToast: {
      message: 'Success! Shift Updated Successfully',
    },
  },

  headerButtons: {
    create: 'Create',
  },

  table: {
    headers: {
      name: 'Name',
      status: 'Status',
      start: 'Start',
      end: 'End',
      year: 'Year',
      direction: 'Direction',
      weekDays: 'weekDays',
    },
    cells: {
      direction: {
        collect: 'Collect',
        distribute: 'Distribute',
        both: 'Collect/Distribute',
      },
      weekDays: {
        weekDaysOptions: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
      status: {
        statusOptions: {
          statusActive: 'Active',
          statusNotActive: 'Not Active',
        },
      },
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createShift: {
        title: 'Create',
      },

      updateShift: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Shift',
        fields: {
          name: 'Name',
          status: 'Status',
          start: 'Start',
          end: 'End',
          year: 'Year',
          direction: 'Direction',
          weekDays: 'Week Days',
        },
      },
      directionOptions: {
        selectDirection: 'Select Direction',
        collect: 'Collect',
        distribute: 'Distribute',
        both: 'Collect/Distribute',
      },
    },
    validations: {
      name: {
        required: 'Name is required',
        name: '',
      },
      start: {
        required: 'Start is required',
        start: '',
      },
      end: {
        required: 'End is required',
        end: '',
      },
      year: {
        required: 'Year is required',
        year: '',
      },
      direction: {
        required: 'Direction is required',
        direction: '',
      },
      weekDays: {
        required: 'You must select at least one day',
        weekDays: '',
      },
    },
    notification: {
      overnight: 'The end time is before the start time, meaning the pickup will be on the following day',
    },
  },
};

export default shifts;
